import { IOperativeStandardsByTripDefSchema } from './operative-standards-by-trip-def.interface';

export interface IOperativeStandardsSettingsSchema {
    punctualityTarget?: number | null;
    restTime?: string | null;
    maxDrivingTime?: string | null;
    segmentedSettings?: IOperativeStandardsByTripDefSchema[];
}
